// extracted by mini-css-extract-plugin
export default {"shareVisioLinkContainer":"_1f2Bk0VoFTqLOutOJJo","shareTestContainer":"X9cn0m0oc4fs8QjxJCuB"};